import React from "react";
import { FaAngleLeft, FaAngleRight } from "react-icons/fa";
import Slider from "react-slick";
const TestimonialOne = () => {
  function SampleNextArrow(props) {
    const { className, onClick } = props;
    return <FaAngleRight className={className} onClick={onClick} />;
  }
  function SamplePrevArrow(props) {
    const { className, onClick } = props;
    return <FaAngleLeft className={className} onClick={onClick} />;
  }
  const settings = {
    dots: false,
    arrows: true,
    infinite: true,
    speed: 1000,
    slidesToShow: 3,
    slidesToScroll: 1,
    initialSlide: 0,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2,
          arrows: false,
        },
      },
      {
        breakpoint: 575,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
        },
      },
    ],
  };
  return (
    <>
      {/* =================== Testimonial One Start ===================*/}
      <div
        className='testimonial-area pd-top-120 pd-bottom-90'
        style={{ backgroundImage: 'url("./assets/img/bg/11.png")' }}
      >
        <div className='container'>
          <div className='section-title'>
            <h6 className='sub-title'>OUR APPLICATIONS</h6>
            <h2 className='title'>Advanced Engineering Services</h2>
          </div>
          <div className='testimonial-slider-1  slider-control-round slider-control-dots slider-control-right-top'>
            <Slider {...settings}>
              <div className='item px-3'>
                <img src='assets/img/testimonial/app1.jpg' alt='img' />
                <h5 className="text-center mt-3">Fertilizer Industry</h5>
              </div>
              <div className='item px-3'>
                <img src='assets/img/testimonial/app2.jpg' alt='img' />
                <h5 className="text-center mt-3">Steel Plants</h5>
              </div>
              <div className='item px-3'>
                <img src='assets/img/testimonial/app3.jpg' alt='img' />
                <h5 className="text-center mt-3">Fabrication</h5>
              </div>
              <div className='item px-3'>
                <img src='assets/img/testimonial/app5.jpg' alt='img' />
                <h5 className="text-center mt-3">Water Treatment Plant</h5>
              </div>
              <div className='item px-3'>
                <img src='assets/img/testimonial/app6.jpg' alt='img' />
                <h5 className="text-center mt-3">Boiler, Heat Exchanger, Condenser, Pulverizer</h5>
              </div>
            </Slider>
          </div>
        </div>
      </div>
      {/* =================== Testimonial One End ===================*/}
    </>
  );
};

export default TestimonialOne;
